import { useQuery } from '@tanstack/react-query';
import { superAdminClientsService } from '@repo/ui/lib/api/services/superadmin-clients.service';

export const myFeaturesQueryKey = ['features', 'me'] as const;

/** Fonctionnalités de l'organisation de l'utilisateur connecté (barre latérale, accès aux pages). */
export const useMyFeatures = () =>
  useQuery({ queryKey: myFeaturesQueryKey, queryFn: () => superAdminClientsService.getMyFeatures(), staleTime: 5 * 60 * 1000 });
